export default function (Alpine) {
	Alpine.directive("share", (el) => {
		Alpine.bind(el, {
			"@click.prevent"() {
				console.log('click')
				if ("share" in navigator) {
					navigator
						.share({
							title: document.title,
							url: document.location.href,
						})
						.catch((error) => console.error(error));
				}
			},

			":style"() {
				return "share" in navigator ? {} : { display: "none" };
			},
		});
	});
}
